import React from "react";
import { sortBy } from "lodash";
import { navigate } from "@reach/router";
import { Viewer } from "components/auth/types";

interface List {
  id: string;
  name: string;
}

interface Props {
  path: string;
  viewer: Viewer;
}

interface State {
  hasListErr: boolean;
}

class ListsIndexPage extends React.Component<Props, State> {
  state = {
    hasListErr: false,
  };

  componentDidMount () {
    // determine which list a user should be redirected to
    const { viewer } = this.props;
    if (viewer.lists && viewer.lists.length) {
      const primaryLists = sortBy(
        viewer.lists.filter((list: List) => !list.name.match(/denial|move/i)),
        "name",
      );
      if (primaryLists.length) {
        setTimeout(() => {
          navigate(`/dash/manager/lists/${primaryLists[0].id}`);
        }, 0);
      } else {
        this.setState({ hasListErr: true });
      }
    } else {
      this.setState({ hasListErr: true });
    }
  }

  render () {
    if (this.state.hasListErr) {
      return (
        <h4 className="text-center">
          Can not find list for your user account. Please ask your supervisor to add a list to your
          account.
        </h4>
      );
    }
    return null;
  }
}

export default ListsIndexPage;
